type BoundingBox = {
  x: number; // top-left x
  y: number; // top-left y
  width: number;
  height: number;
};

export const calculateOverlapPercentage = (
  boxA: BoundingBox,
  boxB: BoundingBox
): number => {
  // Coordinates of the intersection rectangle
  const x1 = Math.max(boxA.x, boxB.x);
  const y1 = Math.max(boxA.y, boxB.y);
  const x2 = Math.min(boxA.x + boxA.width, boxB.x + boxB.width);
  const y2 = Math.min(boxA.y + boxA.height, boxB.y + boxB.height);

  // Compute width and height of the intersection
  const overlapWidth = Math.max(0, x2 - x1);
  const overlapHeight = Math.max(0, y2 - y1);

  const intersectionArea = overlapWidth * overlapHeight;
  const areaA = boxA.width * boxA.height;
  const areaB = boxB.width * boxB.height;
  const unionArea = areaA + areaB - intersectionArea;

  if (unionArea === 0) return 0;

  const iou = intersectionArea / areaB;

  return iou; // return percentage
};
